import { saveClinicalNotes, getClinicalNotes, getConsultationById } from "../../../Common/axios_instance/video_https/video.https";
import { uploadPrescriptionFile } from "../../../Common/axios_instance/azure_https/azure.https";

export const fetchConsultation = (id: string) => getConsultationById(id);

export const fetchClinicalNotes = (id: string) => getClinicalNotes(id);

export const saveClinicalNotesData = (id: string, payload: any) => saveClinicalNotes(id, payload);

export const uploadNotesFile = (file: File, beneficiaryId: string) =>
  uploadPrescriptionFile(file, beneficiaryId, file.name);
